import React, { useContext } from "react";
import { makeStyles } from "@material-ui/core";
import { ForwardMessageContext } from "../../context/ForwarMessage/ForwardMessageContext";

const useStyles = makeStyles((theme) => ({
  checkboxWrap: {
    display: "inline-flex",
    alignItems: "center",
    marginRight: 8,
    cursor: "pointer",
    userSelect: "none",
    verticalAlign: "middle",
  },
  checkbox: {
    position: "absolute",
    opacity: 0,
    pointerEvents: "none",
    "&:focus-visible + $checkboxBox": {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: 2,
    },
  },
  checkboxBox: {
    appearance: "none",
    WebkitAppearance: "none",
    MozAppearance: "none",
    width: 16,
    height: 16,
    border: `2px solid ${theme.palette.primary.main}`,
    borderRadius: 5,
    backgroundColor: "transparent",
    display: "inline-block",
    position: "relative",
    margin: 0,
    flexShrink: 0,
    transition: "all 0.3s ease-in-out",
    "&::before": {
      content: '""',
      backgroundColor: theme.palette.primary.main,
      display: "block",
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%) scale(0)",
      width: 8,
      height: 8,
      borderRadius: 3,
      transition: "all 0.3s ease-in-out",
    },
  },
  checkboxBoxChecked: {
    "&::before": {
      transform: "translate(-50%, -50%) scale(1)",
    },
  },
}));

const SelectMessageCheckbox = ({ message }) => {
  const classes = useStyles();
  const {
    showSelectMessageCheckbox,
    setSelectedMessages,
    selectedMessages,
  } = useContext(ForwardMessageContext);

  if (!showSelectMessageCheckbox) return null;

  const isChecked = selectedMessages.some((selected) => selected.id === message.id);

  const handleSelectMessage = (event) => {
    const checked = event.target.checked;

    setSelectedMessages((current) => {
      if (checked) {
        if (current.some((selected) => selected.id === message.id)) return current;
        return [...current, message];
      }

      return current.filter((selected) => selected.id !== message.id);
    });
  };

  return (
    <label className={classes.checkboxWrap}>
      <input
        type="checkbox"
        className={classes.checkbox}
        checked={isChecked}
        onChange={handleSelectMessage}
      />
      <span className={`${classes.checkboxBox} ${isChecked ? classes.checkboxBoxChecked : ""}`} />
    </label>
  );
};

export default SelectMessageCheckbox;
